import React from 'react';
import { connect } from 'react-redux';
import { Card, CardHeader, CardActions, CardText } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { createQuestion, updateQuestion, deleteQuestion } from '../actions/question';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import EditableAnswerList from '../components/EditableAnswerList';
import {withRouter} from 'react-router';
import Select from 'react-select';
import QuestionDomainLogicSettings from '../components/QuestionDomainLogicSettings';
import { Editor} from 'react-draft-wysiwyg';
import {EditorState, ContentState, convertFromHTML, convertToRaw} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import {uploadImage} from '../actions/sync';
import htmlToDraft from 'html-to-draftjs';
import {getResponse} from '../reducer/response';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {adminCardStyle} from '../containers/AdminHomepage';
import { saveQuestionTranslation } from '../actions/translation';
import {pushTranslation} from '../actions/sync'

window.htmlToDraft = htmlToDraft;
window.convertFromHTML = convertFromHTML;
let editorStyle = {
  height: 400,
  padding: 10
};

let toolbarStyle = {
  width: "100%",
  padding: "10px 0",
  border: 'none',
  borderBottom: '1px solid #efefef'
}

const toEditorState = (html) => {
  if (html === "" || !html) {
    const contentState = ContentState.createFromText("")
    return EditorState.createWithContent(contentState);
  } else {
    var blocksFromHTML;
    var contentBlocks;
    try {
      blocksFromHTML = htmlToDraft(html);
      contentBlocks = blocksFromHTML.contentBlocks;
    } catch(e) {
      blocksFromHTML = convertFromHTML(html);
      contentBlocks = blocksFromHTML.contentBlocks;
    }
    const contentState = ContentState.createFromBlockArray(contentBlocks);
    return EditorState.createWithContent(contentState);
  }
}

const toHtml = (editorState) => {
  return draftToHtml(convertToRaw(editorState.getCurrentContent()))
}

function newBlankQuestion() {
  return {
    new: true,
    title: "",
    description: "",
    category: null,
    answers: [],
    answerType: "normal",
    satisfiedBy: [],
    notesPrompt: "",
    domainLogic: {
      caveats: {},
      criteria: {}
    },
    representationCategory: "Neither" // can be "Representation", "Implementation", "Both" or "Neither"
  }
}

let domainBgStyle = {backgroundColor:"white", color:"black"};

class TrQuestionForm extends React.Component {
  constructor(props) {
    super(props);

    let question = props.question || newBlankQuestion();
    let trQuestion = this.props.translation.questions.find(q => q.engID === this.props.question.id)
    let description = trQuestion ? trQuestion.description : question.description
    let notesPrompt = trQuestion ? trQuestion.notesPrompt : question.notesPrompt
    let title = trQuestion ? trQuestion.title : question.title

    this.state = {
      ...question,
      answers: trQuestion ? trQuestion.answers : question.answers,
      descriptionState: toEditorState(description || ""),
      notesPromptState: toEditorState(notesPrompt || ""),
      titleState: toEditorState(title || ""),
      satisfiedBy: this.idsToQuestions(question.satisfiedBy)
    }

    this.updateAnswers = this.updateAnswers.bind(this);
    this.checkTitle = this.checkTitle.bind(this);
    this.checkAnswers = this.checkAnswers.bind(this);
  }

  // This shortcuts are needed because the db expects an array of ids,
  // but react-select needs objects with a value and label property
  idsToQuestions(ids) {
    if (ids && ids.length) {
      return ids.map((id) => this.props.questions.find((q) => q.id === id));
    } else {
      return [];
    }
  }

  questionsToIds(questions) {
    return questions.map((q) => q.id || q.value);
  }

  render() {
    let header = !this.state.new ? "Update Question" : "New Question";
    let toolbarConfig = {
      image: {
        uploadCallback: this.props.onUpload
      },
      link: {defaultTargetOption: '_blank'}
    }

    let questions;
    let answers;
    if (this.state.answerType === "satisfiedBy") {
      questions = this.state.satisfiedBy || [];
      answers = questions.map((q) => {
        return {
          label: q.title.replace(/<.*?>/gm, ''),
          options: q.answers.map((a) => ({label: q.title.replace(/<.*?>/gm, '') + ": " + a.title, value: a.id}))
        }
      });
    } else {
      answers = this.state.answers.map((a) => ({ value: a.id, label: a.title }));
      questions = [{
        ...this.props.question,
        answers: this.state.answers
      }];
    }

    let trQuestion = this.props.translation.questions.find(q => q.engID === this.props.question.id)

    let includedInSBQs = this.state.new ? [] : this.props.questions.filter((q) => q.answerType === 'satisfiedBy').filter((sbQ) => sbQ.satisfiedBy.includes(this.props.question.id));
    //check if english version has text besides empty html
    let engDescription = convertFromHTML(this.props.question.description).contentBlocks.length === 0 ? "No English description" : this.props.question.description.replace(/<.*?>/gm, '')
    let engNotePrompt = this.props.question.notesPrompt ? convertFromHTML(this.props.question.notesPrompt).contentBlocks.length === 0 ? "No English prompt" : this.props.question.notesPrompt.replace(/<.*?>/gm, '') : "No English Prompt"
    return (
      <Card style={adminCardStyle}>
        <CardHeader
          title={header}
        />
        <CardText>
          <h4 style={{marginTop: 20, fontSize: 14, color: "black", fontWeight: '400', marginBottom:0}}>English Title</h4>
          <h5 style={{marginTop: 20, color: "black", fontWeight: '400', marginBottom:0}}>{this.props.question.title.replace(/<.*?>/gm, '')}</h5>
          <h4 style={{marginTop: 20, color: "black", fontWeight: '400', marginBottom:0}}>Title Translation</h4>
          <h4 style={{marginTop: 20, fontSize: 12, color: "red", fontWeight: '600', display: (this.state.titleErrorText ? 'block' : 'none')}}>{this.state.titleErrorText ? this.state.titleErrorText : null}</h4>

          <Editor toolbar={{
            options: ['inline', 'colorPicker', 'link', 'remove', 'history'],
            inline: {options: ['bold', 'italic', 'underline', 'strikethrough']},
            link: {defaultTargetOption: '_blank'}
            }}
            editorStyle={{height:60}} toolbarStyle={toolbarStyle} editorState={this.state.titleState} onEditorStateChange={this.handleTitleStateChange} />

          <h4 style={{marginTop: 20, fontSize: 14, color: "black", fontWeight: '400', marginBottom:0}}>English Description</h4>
          <h5 style={{marginTop: 20, color: "black", fontWeight: '400', marginBottom:0}}>{engDescription}</h5>
          <h4 style={{marginTop: 20, fontSize: 14, color: "black", fontWeight: '400', marginBottom:0}}>Description Translation</h4>
          <Editor toolbar={toolbarConfig} editorStyle={editorStyle} toolbarStyle={toolbarStyle} editorState={this.state.descriptionState} onEditorStateChange={this.handleDescriptionChange} />
        </CardText>
          {
            (this.state.answerType === 'normal') ? (
              <div>
                <CardText>
                  <h4 style={{marginTop: 20, fontSize: 14, color: "black", fontWeight: '400', marginBottom:0}}>English Answers</h4>
                  <div style={{marginTop: 20, color: "black", fontWeight: '400', marginBottom:0}}>
                    <ul>
                      {this.props.question.answers.map(a => <li key={"trQFormLi" + a.id}>{a.title}</li>)}
                    </ul>
                  </div>
                </CardText>
                <Card style={{width:"90%", margin: "40px auto"}} zDepth={1}>
                  <CardHeader title="Answer Translations" />
                  { this.state.answerErrorText ? <CardText style={{color: "red"}}>{this.state.answerErrorText}</CardText> : null}
                  <EditableAnswerList response={this.props.response} answers={this.state.answers} onUpdate={this.updateAnswers} isTranslation={true} />
                </Card>
              </div>
            ) : null
          }
        <CardText>
          <h4 style={{marginTop: 20, fontSize: 14, color: "black", fontWeight: '400', marginBottom:0}}>English Note Taking Prompt</h4>
          <h5 style={{marginTop: 20, color: "black", fontWeight: '400', marginBottom:0}}>{engNotePrompt}</h5>
          <h4 style={{marginTop: 20, fontSize: 12, color: "grey", fontWeight: '200'}}>Note Taking Prompt Translation</h4>
          <Editor toolbar={toolbarConfig} editorStyle={{...editorStyle, height: 200}} toolbarStyle={toolbarStyle} editorState={this.state.notesPromptState} onEditorStateChange={this.handleNotesPromptChange} />
        </CardText>

        <CardText>
        <CardActions style={{textAlign: 'right'}}>
          <FlatButton onClick={this.cancel.bind(this)} label="cancel" />
          <RaisedButton onClick={this.submit.bind(this)} primary={true} label="Save Question" />
        </CardActions>
        </CardText>
      </Card>
    )
  }

  updateAnswers(answers) {
    this.setState({answers: answers});
  }

  checkTitle() {
    var htmlTitle = toHtml(this.state.titleState);
    if (htmlTitle === "<p></p>" || htmlTitle === "<p></p>\n" || htmlTitle.length === 0) {
      this.setState({titleErrorText: "Question title required"});
      return false;
    } else {
      this.setState({titleErrorText: ""});
      return true;
    }
  }

  checkAnswers() {
    if (this.state.answers.length || this.state.answerType === 'satisfiedBy') {
      this.setState({answerErrorText: ""})
      return true;
    } else {
      this.setState({answerErrorText: "You must specify at least one answer"})
      return false;
    }
  }

  handleDescriptionChange = (v) => {
    this.setState({descriptionState: v});
  }

  handleTitleStateChange = (v) => {
    this.setState({titleState: v});
  }

  handleNotesPromptChange = (v) => {
    this.setState({notesPromptState: v});
  }

  validateFields(){
    //validate each to trigger error text for all that are missing
    let titleValidated = this.checkTitle();
    let answersValidated = this.checkAnswers();

    if(titleValidated && answersValidated){
      return true;
    } else {
      return false;
    }
  }

  submit() {
    if (this.validateFields()) {
      let attrs = {
        engID: this.props.question.id,
        title: toHtml(this.state.titleState),
        description: toHtml(this.state.descriptionState),
        answers: this.state.answers,
        notesPrompt: toHtml(this.state.notesPromptState)
      };

      this.props.onSubmit(this.props.trID, attrs)
      this.goBack(this.state.new);
    } else {
      alert("Required fields are missing.")
    }
  }

  cancel() {
    this.goBack();
  }

  goBack() {
      this.props.router.push("/admin/translation/" + this.props.trID + "/questions");
  }
}

const mapStateToProps = (state, ownProps) => {
  let id = parseInt(ownProps.routeParams.id);
  let trID = parseInt(ownProps.params.trID)
  return {
    trID: trID,
    question: state.questions.find((t) => t.id === id),
    translation: state.translations.find((t) => t.id === trID),
    questions: state.questions,
    options: state.options,
    response: getResponse(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: (trID, props) => {
      dispatch(saveQuestionTranslation(trID, props));
      dispatch(pushTranslation(trID, false));
    },
    onUpload: (file) => dispatch(uploadImage(file))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TrQuestionForm));
